module.exports = __webpack_public_path__ + "img/eon.ac2ceb5f.png";